import VenuesGrid from './VenuesGrid';

export default VenuesGrid;
